import * as AvatarPrimitive from "@radix-ui/react-avatar";
import styled, { css as styledCSS } from "styled-components";

import { Fallback } from "./Fallback.styles";

export const Root = styled(AvatarPrimitive.Root)<{ size?: string }>`
  display: inline-flex;
  width: ${({ size }) =>
    size === "large" ? "80px" : size === "small" ? "24px" : "16px"};
  height: ${({ size }) =>
    size === "large" ? "80px" : size === "small" ? "24px" : "16px"};
  ${({ size }) =>
    size === "extraSmall" &&
    styledCSS`
    & ${Fallback} {
      font-size: 8px;
    }
  `}
`;

export default Root;
